@if (!requireAllowanceItemsSelection) {
  <div>
    <div class="scroll_outer">
      <div class="scroll_inner_small">
        <div class="borderd_table">
          <table class="table table-striped table-hover mb-0">
            <thead>
              <tr>
                <th width="100">Item</th>
                <th width="100">Allowance</th>
                <th width="80" class="text-center">Amount</th>
              </tr>
            </thead>
            <tbody>
              @for (item of allowanceDataList; track item) {
                @if (item.totalAmount !== 0) {
                  <tr>
                    <td class="align-middle">{{item.Name}}</td>
                    <td><input type="number" step="0.01" min="0"
                      class="form-control span_width_100 d-inline form-control-sm inputresp"
                      [value]="0.00" (keyup)="giveAllowanceSubjectCall($event, item)"
                      [(ngModel)]="item.Allowance" (change)="giveAllowanceSubjectCall($event, item)"
                      (blur)="onBlurHandler(item)">@if (EditAllowanceField) {
                      <span class="required"
                      >*</span>
                    }
                  / {{item.totalAmount | currency}}</td>
                  <td class="align-middle text-center">{{item.Balance | currency}}</td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="row mx-0 mt-3">
    <label>Notes@if (AllowanceNotesField) {
      <span class="required">*</span>
    }</label>
    <textarea rows="5" class="form-control" [disabled]="disableAllowanceNote()" (keyup)="emitAllowanceNotes()"
    [(ngModel)]="allowanceNotes" #noteField="ngModel"></textarea>
    @if (AllowanceNotesField && noteField.touched && allowanceNotes === '' && !disableAllowanceNote()) {
      <div class="alert alert-danger"
        >
        <span>
          Notes is required!
        </span>
      </div>
    }
  </div>
</div>
}

@if (requireAllowanceItemsSelection) {
  <div>
    <div class="w-100 allowance-item mb-4">
      <label>Allowance Item</label>
      <div class="allw-contents">
        <select class="form-select select_box select-width" (change)="changeAllowanceItem($event.target.value)"
          [disabled]="disableAllowanceItemSelection()" [(ngModel)]="selectedAllowanceItemId">
          <option value='0'>Select</option>
          @for (allowanceItem of facilityAllowanceItems; track allowanceItem) {
            <option [value]="allowanceItem.Id">
            {{allowanceItem.Name}}</option>
          }
        </select>
        @if (selectedAllowanceItemId != 0 && selectedAllowanceItemId != null && selectedAllowanceItemDetail) {
          <div class="row mx-0 ml-2 alert alert-warning alert-custom"
            >
            @if (selectedAllowanceItemDetail.Type == 583) {
              <span>Allowance Item MinValue:
              {{selectedAllowanceItemDetail.Value}}, MaxValue: {{selectedAllowanceItemDetail.MaxValue}}</span>
            }
            @if (selectedAllowanceItemDetail.Type == 582) {
              <span>Allowance Item Value:
              {{selectedAllowanceItemDetail.Value}}</span>
            }
          </div>
        }
      </div>
    </div>
    <div class="scroll_outer">
      <div class="scroll_inner_small">
        <div class="borderd_table">
          <table class="table table-striped table-hover mb-0">
            <thead>
              <tr>
                <th width="100">Item</th>
                <th width="100">Allowance</th>
                <th width="80" class="text-center">Amount</th>
              </tr>
            </thead>
            <tbody>
              @for (item of allowanceDataList; track item) {
                @if (item.totalAmount !== 0) {
                  <tr>
                    <td class="align-middle">{{item.Name}}</td>
                    <td><input type="number" step="0.01" min="0"
                      [disabled]="selectedAllowanceItemId == 0 || item.Type == 582"
                      class="form-control span_width_100 d-inline form-control-sm inputresp"
                      [value]="0.00" (keyup)="giveAllowanceSubjectCall($event, item)"
                      [(ngModel)]="item.Allowance" (change)="giveAllowanceSubjectCall($event, item)"
                    (blur)="onBlurHandler(item)">/ {{item.totalAmount | currency}}</td>
                    <td class="align-middle text-center">{{item.Balance | currency}}</td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
    @if (VerifyErrorAllowanceItemValue() != 0  && facilityAllowanceItems.length !== 0 && existsAllowanceRecord()) {
      <div class="row mx-0 mt-3 alert alert-danger"
        >
        @if (VerifyErrorAllowanceItemValue() == 2) {
          <span>Allowance Amount cannot be less than
          {{selectedAllowanceItemDetail.Value}}</span>
        }
        @if (VerifyErrorAllowanceItemValue() == 1) {
          <span>Allowance Amount cannot be greater than
          {{selectedAllowanceItemDetail.MaxValue}}</span>
        }
        @if (VerifyErrorAllowanceItemValue() == 3) {
          <span>Allowance Amount should be equal to
          {{selectedAllowanceItemDetail.Value}}</span>
        }
      </div>
    }
    <div class="row mx-0 mt-3">
      <label>Notes</label>
      <textarea rows="5" class="form-control" (keyup)="emitAllowanceNotes()" [(ngModel)]="allowanceNotes"></textarea>
    </div>
  </div>
}